/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import ResponsiveDimensions from "responsive-dimensions-web/dist/responsive-dimensions-web";
import checkifMobile from "is-mobile";
import screenfull from "screenfull";

const DESKTOP_SKETCH = {
  width: 1920,
  height: 1080,
};

const getDesktopSketch = () => DESKTOP_SKETCH;

const MOBILE_SKETCH = {
  width: 1280,
  height: 720,
};

const getMobileSketch = () => MOBILE_SKETCH;

export const isMobile = () => {
  return checkifMobile();
};

export function withResponsiveUtils(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        webResponsiveUtil: this.getWebResponsiveUtil(),
        mobileResponsiveUtil: this.getMobileResponsiveUtil(),
      };
      this.onResize = this.onResize.bind(this); // bind function once
    }

    componentDidMount() {
      window.addEventListener("resize", this.onResize, false);
      this.updateUtils();
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.onResize, false);
    }

    onResize() {
      this.updateUtils();
    }

    getBaseValues = () => {
      if (screenfull.isFullscreen) {
        return {
          width: document.getElementById(
            "irobot-embedded-interactive-experience"
          ).children[0].offsetWidth,
          height: document.getElementById(
            "irobot-embedded-interactive-experience"
          ).children[0].offsetHeight,
        };
      }
      return {
        width: document.getElementById("irobot-embedded-interactive-experience")
          .offsetWidth,
        height: document.getElementById(
          "irobot-embedded-interactive-experience"
        ).offsetHeight,
      };
    };

    getWebResponsiveUtil = () => ({
      getHeightValue: (value) =>
        ResponsiveDimensions.getHeightValue(
          value,
          getDesktopSketch(),
          this.getBaseValues()
        ),
      getWidthValue: (value) =>
        ResponsiveDimensions.getWidthValue(
          value,
          getDesktopSketch(),
          this.getBaseValues()
        ),
      getFontSize: (value) => {
        const size = ResponsiveDimensions.getWidthValue(
          value,
          getDesktopSketch(),
          this.getBaseValues()
        );
        return size >= 10.1 ? size : 10.1;
      },
    });

    getMobileResponsiveUtil = () => ({
      getHeightValue: (value) =>
        ResponsiveDimensions.getHeightValue(
          value,
          getMobileSketch(),
          this.getBaseValues()
        ),
      getWidthValue: (value) =>
        ResponsiveDimensions.getWidthValue(
          value,
          getMobileSketch(),
          this.getBaseValues()
        ),
      getFontSize: (value) => {
        const size = ResponsiveDimensions.getWidthValue(
          value,
          getMobileSketch(),
          this.getBaseValues()
        );
        return size >= 10.1 ? size : 10.1;
      },
    });

    updateUtils = () => {
      this.setState({
        webResponsiveUtil: this.getWebResponsiveUtil(),
        mobileResponsiveUtil: this.getMobileResponsiveUtil(),
      });
    };

    render() {
      const { webResponsiveUtil, mobileResponsiveUtil } = this.state;
      return (
        <WrappedComponent
          {...this.props}
          webResponsiveUtil={webResponsiveUtil}
          mobileResponsiveUtil={mobileResponsiveUtil}
        />
      );
    }
  };
}

export default withResponsiveUtils;
